import { render, staticRenderFns } from "./DetailTemplate.vue?vue&type=template&id=87908ce4&scoped=true&"
import script from "./DetailTemplate.vue?vue&type=script&lang=js&"
export * from "./DetailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DetailTemplate.vue?vue&type=style&index=0&id=87908ce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87908ce4",
  null
  
)

export default component.exports